import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const ApiSubscribersAccessRight = {
  VIEW_API_SUBSCRIBERS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
} satisfies Record<string, AuthenticationAccessRight>;
